//import Orders from "@/views/Shop/Order/Orders.vue";
import Options from "@/views/Shop/Options/Options.vue";
import OptionsCreate from "@/views/Shop/Options/OptionsCreate.vue";
import OptionsEdit from "@/views/Shop/Options/OptionsEdit.vue";
const routes = [
    /*   {
      path: "/secure/shop/orders",
      name: "Orders",
      component: Orders,
    }, */
    {
        path: "/secure/shop/options",
        name: "OptionsList",
        component: Options,
    },
    {
        path: "/secure/shop/options/create",
        name: "OptionsCreate",
        component: OptionsCreate,
    },
    {
        path: "/secure/shop/options/edit/:option_uuid",
        name: "OptionsEdit",
        component: OptionsEdit,
    },
];
export default routes;
